import styled from 'styled-components';
import Dollar from '@lendi-ui/icon/Dollar';

export const DollarWithMargin = styled(Dollar)`
  margin-left: 10px;
`;
